import React from 'react';
import styled from 'styled-components';

import { CircularLoader } from '../../../shared';

//region STYLED
const StyledDataStatusHandler = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5rem;
  flex: 1;
  z-index: 1;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5); /* Adjust the opacity as needed */
    z-index: 1000; /* Adjust the z-index to be on top of your content */
  }
`;
//endregion

export const DataStatusHandler = ({ message, isLoading, showNoDataMessage, showLoader = false }: any) => {
  if (!isLoading && !showNoDataMessage) {
    return null;
  }

  return (
    <StyledDataStatusHandler>
      {isLoading && showLoader && <CircularLoader />}
      {!isLoading && showNoDataMessage && <h5>{message || 'No Data'}</h5>}
    </StyledDataStatusHandler>
  );
};
